export default __webpack_public_path__ + "static/cover-completely-8ac6c3dd85e323adb650f44e69fb49e6.png";